import React, { FC, useEffect, useRef } from 'react';
import SignatureCanvas from 'react-signature-canvas';
import useDimension from '../../../../hooks/useDimension';
import SignatureValues from '../../../../pages/registrations/submissions/components/SignatureValues';

export interface Props {
  onChange: (val: string) => void;
  onTouched: () => void;
  readOnlyMode?: boolean;
  img?: string;
}

interface SignatureCanvasRefModel extends SignatureCanvas {
  getTrimmedCanvas: () => SignatureCanvasRefModel;
  toDataURL: () => string;
  clear: () => void;
}

const Signature: FC<Props> = ({ onChange, onTouched, readOnlyMode, img }: Props) => {
  const sigContainer = useRef(null);
  const sigCanvas = useRef<SignatureCanvasRefModel>(null);
  const { width } = useDimension(sigContainer);

  useEffect(() => {
    if (!img) {
      onChange('');
    }
  }, [width]);
  if (readOnlyMode) {
    return <SignatureValues img={img} />;
  } else {
    return (
      <div ref={sigContainer} className="signature-field" data-testid="signature-field-test">
        <SignatureCanvas
          ref={sigCanvas}
          canvasProps={{ height: 140, width: width - 3, className: 'signature-field-canvas' }}
          onEnd={async () => {
            const sigRef = sigCanvas.current;
            if (sigRef) {
              await onChange(sigRef.getTrimmedCanvas().toDataURL());
              await onTouched();
            }
          }}
        />
        <div className="line-signature"></div>
        <div className="draw-signature">
          <span className="mdi mdi-draw icon-signature"></span>
        </div>
        <div className="eraser-signature">
          <span
            className="mdi mdi-eraser icon-signature"
            onClick={async () => {
              const sigRef = sigCanvas.current;
              if (sigRef) {
                await onChange('');
                await onTouched();
                sigRef.clear();
              }
            }}
            data-testid="erase-icon-test"
          ></span>
        </div>
      </div>
    );
  }
};

export default Signature;
